var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detailNav"},[_c('ul',_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"titleItem",class:{itemActive:index==_vm.active},on:{"click":function($event){return _vm.handleClick(item,index)}}},[_vm._v(_vm._s(item.title))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }